// removed by extract-text-webpack-plugin
module.exports = {"container":"_2DUXzRJGTS4OX1SphI_4Ja","content":"_1TbfT203pbA-DhwGoujRTR","removed":"_3mIYSU74fSVf8ZM7CSjm0X"};


//////////////////
// WEBPACK FOOTER
// ./app/components/Order/style.scss
// module id = 1238
// module chunks = 0